import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash-es';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { TrackingHandler } from 'client/tracking/handler';
import { TrackingMap } from 'client/tracking/maps/consumer-reviews/write-review/write-review';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { ConsumerReviewsParams } from 'site-modules/shared/utils/consumer-reviews/params';
import { buildVehiclePath, VehicleEntities, VehicleModel } from 'client/data/models/vehicle-v2';
import { getUrlPathFromParams } from 'site-modules/shared/utils/core-breadcrumbs-builder';
import { CoreBreadcrumbs } from 'site-modules/shared/components/core-breadcrumbs/core-breadcrumbs';
import { WriteReviewForm } from 'site-modules/write-review/components/write-review-form/write-review-form';

const PAGE_DISPLAY_NAME = 'Write a Review';
const URL_PATH = 'write-review';

function WriteReviewUI({ vehicleParams, vehicle = null, location, isConfirmed = false }) {
  useEffect(() => {
    TrackingHandler.useMap(TrackingMap);
  }, []);

  if (!vehicle) {
    return (
      <main id="main-content" tabIndex={-1} className="write-review">
        <Container>Loading&hellip;</Container>
      </main>
    );
  }

  return (
    <main id="main-content" tabIndex={-1} className="write-review">
      <Container className="pb-1_5">
        <CoreBreadcrumbs
          className="ps-0"
          vehicle={vehicle}
          breadcrumbsParams={{
            params: vehicleParams,
            pageDisplayName: PAGE_DISPLAY_NAME,
            urlPath: getUrlPathFromParams(vehicleParams, URL_PATH),
          }}
        />
        <Row>
          <Col xs={12} lg={8}>
            <WriteReviewForm vehicle={vehicle} location={location} isConfirmed={isConfirmed} />
          </Col>
        </Row>
      </Container>
    </main>
  );
}

WriteReviewUI.propTypes = {
  vehicleParams: ConsumerReviewsParams.isRequired,
  isConfirmed: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  vehicle: VehicleEntities.MakeModelSubmodelYear,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
  location: get(state, 'pageContext.location', {}),
});

export const WriteReview = connect(mapStateToProps)(
  connectToModel(WriteReviewUI, {
    vehicle: bindToPath(({ vehicleParams }) => buildVehiclePath(vehicleParams), VehicleModel),
  })
);
